import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
export var PermissionsContext = createContext(undefined);
export var Can = createContextualCan(PermissionsContext.Consumer);
